<template>
  <helper-layout :loaded="mx_loaded">
    <div class="pos-total">
      <material-table
        :search-data="searchData"
        :headers="headers"
        :items="monthlyBillData.billList.items"
        :paginate="paginateConfig"
        :total-count="monthlyBillData.billList&&monthlyBillData.billList.totalCount"
        @pageChange="handlePageChange"
        @searchChange="handleSearchChange"
      >
        <!-- 表格顶部数据 -->
        <template v-slot:totalbar>
          <v-layout justify-center class="pa-1 total-items">
            <v-flex v-for="(item,idx) in monthlyNotDeductBalance" :key="item.key" align-self-center>
              {{ $t('Views.Finance.YYYY-MM', { '0': selectedYear, '1': selectedMonth}) }}
              {{ billMap[item.key] }}
              {{ idx===0?'￥':'$' }}{{ $util.data.toThousands(item.value) }}
            </v-flex>
          </v-layout>
        </template>
      </material-table>
    </div>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import { format, subMonths } from 'date-fns'
const prevMonth = format(subMonths(new Date(), 1), 'YYYY-MM')

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        // {
        //   text: $t('Views.Finance.customer_search_label'),
        //   value: 'customerInfo',
        //   align: 'left',
        //   renderHeader: (h, params) => {
        //     return h(
        //       'div',
        //       {
        //         domProps: {
        //           innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.customerNum')
        //         }
        //       }
        //     )
        //   },
        //   render: (h, param) => {
        //     const text = param.row.customer.name + (param.row.customer.serialNumber ? '<br />' + param.row.customer.serialNumber : '')
        //     return h('div', {
        //       domProps: {
        //         innerHTML: text
        //       }
        //     })
        //   }
        // },
        { // 客户名称 新客户名称
          text: $t('Views.Finance.customer_search_label'),
          value: 'customerInfo',
          align: 'left',
          renderHeader: (h, params) => {
            return h(
              'div',
              {
                domProps: {
                  innerHTML: $t('Views.Order.clientName') + '<br/>' + $t('Views.Order.newCustomerNumList')
                }
              }
            )
          },
          render: (h, param) => {
            const text = param.row.customer ? param.row.customer.name + (param.row.customer.newSerialNumber && param.row.customer.serialNumber ? '<br />' +
              param.row.customer.newSerialNumber : param.row.customer.newSerialNumber ? '<br />' + param.row.customer.newSerialNumber : '<br />' + param.row.customer.serialNumber) : '--'
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          text: $t('Views.Finance.sales'),
          value: 'salesName'
        },
        {
          text: $t('Views.Finance.orderNumbers'),
          value: 'number'
        },
        {
          text: $t('Views.Finance.orderPrice'),
          value: 'targetCurrencyPrice',
          render: (h, params) => {
            return h('div', this.$util.data.moneyFmt(params.row.targetCurrencyPrice, params.row.currencyName))
          }
        },
        // {
        //   text: $t('Views.Finance.shipmentPrice'),
        //   value: 'targetCurrencyShipmentPrice',
        //   isCurrency: true
        // },
        {
          text: $t('Views.Finance.paymentCurrency'),
          value: 'currencyName',
          render: (h, params) => {
            return h('label', ENUMS.currencyName[params.row.currencyName])
          }
        },
        // {
        //   text: $t('Views.Finance.settlementType'),
        //   value: 'settlementType',
        //   render: (h, params) => {
        //     return h('div', ENUMS.settlementType[params.row.settlementType])
        //   }
        // },
        {
          text: $t('Views.Finance.paymentBillDate'),
          value: 'paymentBillDate',
          type: 'date'
        },
        {
          text: $t('Views.Finance.status'),
          value: 'status',
          render: (h, params) => {
            return h(
              'div',
              {
                style: {
                  color: ENUMS.payStatus[params.row.status].color
                }
              },
              ENUMS.payStatus[params.row.status].text
            )
          }
        }
        // {
        //   text: $t('Views.Finance.isDeduct'),
        //   value: 'isDeduct',
        //   render: (h, params) => {
        //     return h(
        //       'div',
        //       params.row.isDeduct
        //         ? this.$t('Views.Finance.true')
        //         : this.$t('Views.Finance.false')
        //     )
        //   }
        // }
      ],
      searchData: [
        {
          key: 'customerFilter',
          value: '',
          label: $t('Views.Finance.customer_search_label'),
          placeholder: $t('Views.Finance.nameOrSN')
        },
        {
          key: 'salesId',
          name: $t('Views.Finance.sales'),
          placeholder: $t('Views.Finance.pleaseSelectSales'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          id: '',
          state: []
        },
        // {
        //   key: 'beautyAdvisorsId',
        //   name: $t('Views.Finance.beautyAdvisors'),
        //   placeholder: $t('Views.Finance.pleaseSelectBeautyAdvisors'),
        //   type: 'select',
        //   itemText: 'name',
        //   itemValue: 'id',
        //   state: []
        // },
        {
          key: 'billDate',
          //  value: this.$util.tool.localToUtc(prevMonth),
          value: prevMonth,
          label: $t('Views.Finance.billDate'),
          icon: 'mdi-calendar',
          type: 'month',
          config: {
            clearable: false
          },
          default: prevMonth
        },
        {
          key: 'currencyIds',
          label: $t('Views.Finance.paymentCurrency'),
          value: '',
          type: 'select',
          state: this.$util.tool.enumToSelect(ENUMS.currencyIds)
        },
        {
          key: 'status',
          label: $t('Views.Finance.status'),
          value: '',
          type: 'select',
          state: this.$util.tool.enumToSelect(ENUMS.payStatus)
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        customerFilter: '',
        salesId: [],
        billDate: null,
        currencyIds: [],
        // settlementTypes: [],
        status: '',
        skipCount: 0,
        maxResultCount: 10
      },
      selectedMonth: null,
      selectedYear: null,
      query: null,
      monthlyNotDeductBalance: [],
      billMap: {
        JPY: $t('Views.Finance.MonthlyTotalYenBalance'),
        USD: $t('Views.Finance.MonthlyTotalDollarBalance')
      }
    }
  },
  computed: {
    ...mapState('finance', ['monthlyBillData']),
    ...mapState('setting', ['staffAllData'])
  },
  mounted() {
    this.query = this.$route.query
    this.form.billDate = prevMonth
    this.form.customerFilter = this.query.mail
    this.searchData[0].value = this.query.mail
    this.selectedYear = prevMonth.split('-')[0]
    this.selectedMonth = prevMonth.split('-')[1]
    this.getPage()
    this.getStaff()
  },
  methods: {
    ...mapActions('finance', ['getMonthlyBills']),
    ...mapActions('setting', ['getStaffAllData']),
    getStaff() {
      this.getStaffAllData({ isActive: true, permissionCheck: true }).then(
        () => {
          this.searchData[1].state = this.staffAllData.items
        }
      )
    },
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getMonthlyBills(this.form).then(() => {
        this.monthlyNotDeductBalance = this.monthlyBillData.monthlyNotDeductBalance
        this.paginateConfig.total = this.monthlyBillData.billList.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSearchChange(search) {
      const { billDate } = search
      this.selectedYear = format(billDate || prevMonth, 'YYYY')
      this.selectedMonth = format(billDate || prevMonth, 'MM')
      this.form = {
        ...this.form,
        ...search
      }
      this.getPage(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.total-items {
  padding: 0 !important;
  height: 80px;
  margin-bottom: 24px;
  color: #515151;
  & /deep/ > .flex {
    flex-wrap: nowrap;
    text-align: center;
    line-height: 80px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 700;
  }

  & /deep/ .flex:not(:last-child) {
    margin-right: 20px;
  }
}
</style>
